<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.65356 9.5791L5.65356 12.4206" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
<rect x="1.85" y="6.28945" width="18.3" height="9.42073" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
</svg>
